import { stringifyTurtleNamespaces } from 'src/utils/stringify/namespaces';
import { COMMON_NAMESPACES } from 'src/utils/voicebox/prompts/constants';

export const fixTurtle = (code: string) => {
  const lowerCaseCode = code.toLowerCase();
  const prefixes = stringifyTurtleNamespaces(
    Object.fromEntries(
      Object.entries(COMMON_NAMESPACES)
        .filter(
          // don't output prefix if it already exists
          ([prefix]) => !lowerCaseCode.includes(`@prefix ${prefix}:`)
        )
        .filter(([prefix]) =>
          // only output prefixes (roughly) used
          lowerCaseCode.match(new RegExp(`\\b${prefix}:`))
        )
    )
  );

  // @prefix urn:skynet: <> .
  // @prefix urn:skynet: <urn:skynet:> .
  const fixedCode = code
    .trim()
    // no empty iri's
    .replace(/^(@prefix .+? <> \.)$/im, '# $1')
    // no iri's in prefix part like "@prefix urn:thing:"
    .replace(/^(@prefix [a-z]+:[a-z]+.*)$/im, '# $1');

  const codeWithATonOfPrefixes = `${prefixes}\n# start of real prompt result:\n${fixedCode}`;
  return codeWithATonOfPrefixes.trim();
};
